import React, {Component} from 'react'; 
import styled from 'styled-components'; 

        const CardContainer = styled.div`
            height: ${props => `${props.containerHeight}px`}; 
            transition: height 0.3s ease;
            background: #fff;
            /* border-radius: 3px;
            box-shadow: 0 3px 7px -3px rgba(0, 0, 0, 0.3); */
            margin-top: 15px;
            margin-bottom : 15px; 
            margin-left:15px; 
            margin-right:15px;
            overflow: hidden;
            position: relative;
            font-size: 14px;
            line-height: 1.45em;
            box-sizing: inherit; 
        `
        const Summary = styled.p`
            text-align: justify; 
            font-family: "Open Sans"; 
            font-size : 14px; 
            position: relative;
            margin: 0;
            padding-top: 20px;
            &:after {
                box-sizing: inherit!important; 
                content: "";
                background: ${props=> props.primaryColor};
                height: 4px;
                width: 70px;
                position: absolute;
                top: 6px;
                left: 42%;
              }
        `
        const Description = styled.div`
            padding: 10px;
            box-sizing: border-box;
            position: relative;
            float: left;
            width: 60%;
            z-index: 0;
            height: 100%;
            &:before{
                box-sizing: inherit!important; 
                transform: skewX(-5deg);
                content: "";
                background: #fff;
                width: 100%;
                z-index: -1;
                position: absolute;
                left: -15px;
                top: 0;
                bottom: 0;
            }
        `

        const DescriptionTitle = styled.h3`
            font-family: "Oswald";
            font-weight: 400;
            margin: 0 0 10px 0;
        `

        const Photo = styled.div`
            position: relative;
            transition: all 0.5s ease;
            float: left;
            background-image: ${props=> `url(${props.imageUrl})`};
            background-repeat: no-repeat; 
            background-size: cover;  
            height: 100%;
            width: 40%;
        `

export class NewsHorizontalCard extends Component {

    render()
    {
        const { news, newsNumber, primaryColor, containerHeight } = this.props 
 
        if (news.length === 0) return null
        return (
            news.items.slice(0, newsNumber).map((article, i) =>  
            <CardContainer containerHeight={containerHeight} key={i}>
            <Photo imageUrl={article.image.split("|")[0]}></Photo>
            <Description>
                <DescriptionTitle>{article.title}</DescriptionTitle>
                <Summary primaryColor={primaryColor}>{article.description.split("...")[0]}...</Summary>
            </Description>
            </CardContainer>

        ))
    }

}



// WEBPACK FOOTER //
// ./src/components/News/NewsHorizontalCard/index.js